<template>
  <v-main>
    <AppBar/>
    <v-layout v-if="schedule" fill-height column>
      <v-container fluid class="pt-0" v-if="!useStopYn ">
        <h1 class="fs-24 fw-700 mb-1" v-if="!isReserved">일주일 뒤에 다시 만나요!</h1>
        <h1 class="fs-24 fw-700 mb-1" v-if="isReserved">예약된 중지 일정이에요.</h1>
        <div class="subtitle--text fs-14 fw-300">
          현재 티켓 중지 가능 횟수 <span class="primary--text fw-500">{{ availStopCnt + '회' }}</span><br>
          가능기간 <span class="primary--text fw-500">{{ availStopDay + '일' }}/{{ availStopCnt + '회' }}</span> 가 남아있습니다.
        </div>
      </v-container>
      <v-container fluid class="pt-0" v-if="useStopYn">
        <h1 class="fs-24 fw-700 mb-1">현재 쉬는 중이에요.</h1>
        <div class="subtitle--text fs-14 fw-300">
          현재 티켓 중지 가능 횟수 <span class="primary--text fw-500">{{ availStopCnt + '회' }}</span><br>
          가능기간 <span class="primary--text fw-500">{{ availStopDay + '일' }}/{{ availStopCnt + '회' }}</span> 가 남아있습니다.
        </div>
      </v-container>
      <hr class="hr"/>
      <v-container flex-fill fluid>

        <div class="pause-schedule" @click.prevent="onOpenCalendar">
          <template v-if="thisStartDate && thisEndDate">
            <div class="pause-schedule-title">
              <span>중지 시작일</span>
              <span>중지 종료일</span>
            </div>
            <div class="pause-schedule-text">
              <span class="date">{{ getTextDate(thisStartDate) }}</span>
              <span>-</span>
              <span class="date" :class="{'red--text font-weight-bold' : isAbleSolutionStop}">
                {{ getTextDate(thisEndDate) }}
              </span>
              <v-icon v-if="isAbleSolutionStop">mdi-calendar-range</v-icon>
            </div>
          </template>
          <div v-else class="pause-schedule-empty">
            중지 기간을 설정해 주세요.
            <v-icon v-if="isAbleSolutionStop">mdi-calendar-range</v-icon>
          </div>
        </div>

        <ul class="list dot dot-sm">
          <li>중지하는 기간만큼 티켓의 전체 일정이 <span class="red--text">7일 연장</span>됩니다.</li>
          <li>설정한 중지 기간이 경과하면 자동으로 티켓이 재개됩니다.</li>
        </ul>
      </v-container>
      <div class="footer-btns vertical">
        <v-btn color="primary" class="btn-basic" v-if="isAbleSolutionStop"
               x-large depressed
               :disabled="thisStartDate === null || thisEndDate === null"
               @click="submit">중지하기
        </v-btn>
        <v-btn color="primary" class="btn-basic" v-if="isReserved"
               x-large depressed
               @click="cancelReservation">예약 취소하기
        </v-btn>
        <v-btn color="primary" class="btn-basic" v-if="useStopYn"
               x-large depressed
               @click="confirm">확인
        </v-btn>

        <v-btn color="primary" class="btn-cancel"
               x-large depressed
               v-if="isAbleSolutionStop"
               @click="confirm">계속하기
        </v-btn>
      </div>
    </v-layout>
    <!-- 일시중지 달력 -->
    <SolutionPauseSheet ref="SolutionPauseSheet"
                        :avail-stop-day="availStopDay"
                        :selected-start-date="thisStartDate"
                        :ticket-end-date="ticketEndDate"
                        @selectValue="setPausePeriod" />
    <v-overlay opacity="1" color="white" :value="isLoading">
      <v-progress-circular
          indeterminate
          size="64"
          color="primary"
      />
    </v-overlay>
  </v-main>
</template>
<script>
import store from '@/store';
import Util from '@/utils/utils'
import { mixinAuth, mixinRemote } from '@/mixins'
import SolutionPauseSheet from '@/components/layout/bottomSheet/SolutionPauseSheet'

export default {
  components: {
    SolutionPauseSheet
  },
  mixins: [ mixinAuth, mixinRemote ],
  data: () => ({
    isLoading: false,
    schedule: null,
    availStop: false, // 중지 가능 상태
    availStopDay: 7, // 이용 중지 기간
    availStopCnt: 1,
    useStopYn: false, // 중지 상태
    isReserved: false,
    thisStartDate: null, // YYYY-MM-DD
    thisEndDate: null // YYYY-MM-DD
  }),
  computed: {
    ticketEndDate () {
      return Util.Date.toDate(this.usePeriodEndDt)
    },
    isAbleSolutionStop () {
      return !this.useStopYn && !this.isReserved
    }
  },
  created() {
    this.findChatScheduleByUserList();
  },
  mounted() {
    // this.findChatScheduleByUserList();
  },
  methods: {
    getNumberDate (value) {
      if (value) return Util.Date.toFormatDate(value,  'YYYYMMDD')
    },
    getTextDate (value) {
      if (value) return Util.Date.toFormatDate(value,  'YYYY년 M월 D일')
    },
    onOpenCalendar () {
      if (this.isAbleSolutionStop) {
        this.$refs.SolutionPauseSheet.openSheet()
      }
    },
    setPausePeriod(value) {
      this.thisStartDate = value.start
      this.thisEndDate = value.end
      this.$refs.SolutionPauseSheet.closeSheet()
    },
    async findChatScheduleByUserList() {
      this.isLoading = true
      let params = [{ memberNo: this.userKey }]
      await store.dispatch('findChatScheduleByUserList', this.$_payload('so', params))
        .then(res => {
          if (res.success) {
            let today = Util.Date.getToday('YYYYMMDD')
            this.schedule = res.data
            this.useStopYn = this.schedule.useStopYn
            this.availStopCnt -= this.schedule.useStopNum

            // 이용 중지 가능 체크
            if (!this.schedule.availStop) {
              this.availStopCnt = 0
              this.availStopDay = 0
            }

            if (this.availStopCnt === 0) {
              this.availStopDay = 0;
            }

            if (this.schedule.useStopEndDt != null && (this.useStopYn || this.getNumberDate(this.schedule.useStopEndDt) > today)) {
              this.thisStartDate = Util.Date.toDate(this.schedule.useStopStartDt)
              this.thisEndDate = Util.Date.toDate(this.schedule.useStopEndDt)
              if (!this.useStopYn) {
                this.isReserved = true
              }
            }
          } else {
            this.$alert(res.msg).then(() => {
              this.$router.back()
            })
          }
        })
        .catch(error => {
          console.error(error)
          this.$alert('오류').then(() => {
            this.$router.back()
          })

        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async submit() {
      let fDate = this.thisStartDate

      if (this.availStopCnt === 0) {
        this.$alert("일시 중지 가능 횟수가 초과되었어요!")
        return false;
      }
      if (this.getNumberDate(fDate) <= this.getNumberDate(new Date())) {
        this.$alert("티켓 일시중지 시작날짜는<br/> 익일부터 가능합니다.")
        return false;
      }

      this.$confirm('티켓을 일시 중지하시겠어요?', {
        persistent: false,
        showClose: true,
        actions: {
          false: {text: '취소'},
          true: {text: '일시 중지하기'}
        }
      }).then(result => {
        if (result) {
          let params = {
            ordDtlNo: this.schedule.ordDtlNo,
            useStopStartDt: this.thisStartDate,
            useStopEndDt: this.thisEndDate,
            cusWdCd: this.schedule.cusWdCd,
            cusTimeCd: this.cusTimeCd
          }
          store.dispatch('pauseSolution', this.$_payload('po', params))
            .then(res => {
              if (res.success) {
                this.$root.$children[0].$refs.toast.toastOpen('top', '티켓 일시중지가 예약 되었습니다.')
                window.location.reload(true);
              } else {
                this.$alert(res.msg)
              }
            })
            .catch(error => {
              console.error(error)
            })
            .finally(() => {})
        }
      })
    },
    async cancelReservation() {
      this.$confirm('일시 중지 예약을 취소하시겠어요?', {
        persistent: false,
        showClose: true,
        actions: {
          false: {text: '취소'},
          true: {text: '예약 취소하기'}
        }
      }).then(result => {
        if (result) {
          let params = {
            ordNo: this.schedule.ordNo,
            ordDtlNo: this.schedule.ordDtlNo,
            useStopStartDt: this.thisStartDate,
            useStopEndDt: Util.Date.getToday(),
            cusWdCd: this.schedule.cusWdCd,
            cusTimeCd: this.schedule.cusTimeCd
          }

          store.dispatch("cancelStopSolution", this.$_payload('po', params))
            .then(res => {
              console.log(res)
              this.$root.$children[0].$refs.toast.toastOpen('top', '티켓 중지가 취소되었습니다.')
              this.movePage('/')

            })
            .catch(error => {
              console.error(error)
            })
            .finally(() => {})
        }
      })
    },
    confirm() {
      if (this.back) this.back()
      else this.prevPage()
      // this.movePage('/fo/chatting')
    }
  }
}
</script>
